export default "__VITE_ASSET__Ck2bf1x$__"